<template>
    <div class="content">
        <!-- title -->
        <div v-if="JSON.stringify(this.pageHeader) !== '{}'" class="headline">
            <div class="head-top">{{ pageHeader.service.name }}</div>
            <!-- left -->
            <div class="head-left">
                <div class="head-left-img"></div>
                <div class="head-left-top">{{ pageHeader.check.new_name }}</div>
            </div>
            <hr class="line" />
            <div class="head-left-bot">
                <div>已验收项目：{{ pageHeader.nums.total }}</div>
                <div>问题数：{{ pageHeader.nums.problem_num }}</div>
            </div>
        </div>
        <!-- content -->
        <div class="table-cent">
            <div class="table-list">
                <div class="table-head head-line font-text5">
                    <template v-for="(item, index) in tableHead" >
                        <div v-show="item != '城市'" :key="index">{{ item }}</div>
                    </template>
                </div>
                <template v-if="tableList.length > 0">
                    <div v-for="(item, index) in tableList" :key="index" @click="tableItem(item)" class="table-head item-line font-text5">
                        <div>{{ index + 1 }}</div>
                        <div v-show="false">武汉</div>
                        <div>{{ item.company_name }}</div>
                        <div>{{ item.contract_num }}</div>
                        <div>{{ item.problem_num }}</div>
                        <div class="icon-arrow"></div>
                    </div>
                </template>
            </div>
        </div>

        <!-- 悬浮按钮 -->
        <Drag></Drag>
    </div>
</template>

<script>
import Drag from "../components/drag.vue";
export default {
    components: {
        Drag,
    },
    data() {
        return {
            tableHead: ["排序", "城市", "服务商名称", "完工项目", "问题数"], // table 头部
            tableList: [],  // 表格数据

            pageHeader: {}, // 页面top数据
        };
    },
    created() {
        $init(() => {
            this.$store.commit("loadSwitch", true);  // 页面loading开启
            let that = this;
            let project_id = that.$store.state.questionId;  // 服务评分--服务商id
            let process_id = that.$store.state.processId;  //服务评分--高频问题-验收子类id
            let service_id = that.$store.state.serviceId;  // 服务评分--高频问题-验收内容id
            Promise.all([
                that.$userHouse.dispatch("getTableHeadr", { project_id, process_id, service_id }),
                that.$userHouse.dispatch("getTableBttom", { project_id, process_id, service_id }),
            ]).then((res) => {
                that.pageHeader = that.$userHouse.state.scoreHeader;  // 页面top 数据
                that.tableList = that.$userHouse.state.scoreTable;   // 页面表格数据

                this.$store.commit("loadSwitch", false);// 页面loading关闭
            });
        });
    },
    methods: {
        tableItem(query) { // 进入table详情
        console.log(query)
            this.$router.push({ path: `/service/higtproblems/proxytopitem?id=${JSON.stringify(query)}&isWholeCountry=true` });
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    background: $userBg;
    .headline {
        margin: 28px 24px;
        background: #ffffff;
        border-radius: 16px;
        .head-top {
            padding: 28px;
            background: linear-gradient(136deg, #4ea062 0%, #338444 100%);
            border-radius: 12px;

            font-size: 32px;
            font-weight: 500;
            color: #ffffff;
        }

        .head-left {
            display: flex;
            padding-top: 38px;
            .head-left-img {
                margin: 0 12px 0 24px;
                width: 36px;
                height: 36px;
                background: url(~@/assets/images/user/house/problem1_icon.png)
                    no-repeat center/100% 100%;
            }
            .head-left-top {
                flex: 1;
                font-size: 28px;
                font-weight: 400;
                color: #444444;
            }
        }
        .line {
            position: relative;
            top: 24px;
            left: 50%;
            width: calc(100% - 48px);
            transform: translateX(-50%);
            border-top: 1px dashed rgba(200, 225, 206, 1);
        }
        .head-left-bot {
            margin: 24px 0 0 24px;
            padding: 26px 0;
            display: flex;
            align-items: center;

            font-size: 28px;
            font-weight: 500;
            div:first-of-type {
                padding-right: 58px;
            }
            div:last-of-type {
                color: #eb6f56;
            }
        }
    }
    .table-cent {
        padding: 28px 24px;
        .table-list {
            padding: 32px 24px 18px 24px;
            background: $divBg;
            border-radius: 12px;
            .table-head {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: center;
                div:nth-child(1) {
                    width: 52px;
                }
                div:nth-child(2) {
                    width: 52px;
                }
                div:nth-child(3) {
                    width: 148px;
                }
                div:nth-child(4) {
                    width: 100px;
                }
                div:nth-child(5) {
                    width: 88px;
                }

                .icon-arrow {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: -15px;
                    width: 30px;
                    height: 38px;
                    background: url(~@/assets/images/user/house/font_right.png)
                    no-repeat center/100% 100%;
                }
            }
            .head-line {
                color: $deepGreen;
                padding-bottom: 24px;
                border-bottom: 1px solid rgba(241, 241, 241, 1);
            }
            .item-line {
                padding: 24px 0;
                border-bottom: 1px dashed rgba(241, 241, 241, 1);
                div:last-of-type {
                    color: $deepGreen;
                }
            }
        }
    }
}
// 卡片标题字号 - 14 个样式
.font-text {
    // 28
    font-size: $baseSize;
    font-weight: 500;
}
.font-text1 {
    // 24
    font-size: $smallSize;
    font-weight: 400;
}
.font-tex2 {
    // 28
    font-size: $baseSize;
    font-weight: 400;
}
.font-tex3 {
    // 32
    font-size: $bigSize;
    font-weight: 500;
}
.font-text5 {
    // 24
    font-size: $smallSize;
    font-weight: 500;
}
</style>